import gql from 'graphql-tag';

export default gql`
    mutation SaveCarrier($input: SaveCarrierInput) {
        saveCarrier(input: $input) {
            errors
        }
    }
`;
